import React from "react";
import Grid from '@mui/material/Grid';

const SelectedWorks = () => {
  return (
    <Grid item xs={4}>                    
      <div className="project__title__h1"> SELECTED 
        <div className="project__title__h1__sub">WORKS</div>
      </div>
    </Grid>
  )
}

export default SelectedWorks;